export { default as Badge } from './Badge';
export type { BadgeProps, BadgeNumberVariant, BadgeDefaultVariant } from './types';
